import type { Dispatch, SetStateAction } from "react";

import { Trash2 } from "lucide-react";

import { ConfirmationModal } from "@/components/confirmation-modal";

interface DeleteAllAssetsModalProps {
  isDeleting?: boolean;
  isOpen: boolean;
  onConfirm: () => void;
  onOpenChange: Dispatch<SetStateAction<boolean>>;
}

export function DeleteAllAssetsModal({
  isDeleting = false,
  isOpen,
  onConfirm,
  onOpenChange,
}: DeleteAllAssetsModalProps) {
  return (
    <ConfirmationModal
      confirmButtonColor="destructive"
      confirmButtonText="Delete all"
      icon={<Trash2 className="text-featured-icon-light-fg-error" />}
      isConfirmLoading={isDeleting}
      isOpen={isOpen}
      onConfirm={onConfirm}
      onOpenChange={onOpenChange}
      text="Are you sure you want to delete all files? This action cannot be undone."
      title="Delete all files"
    />
  );
}
